// Where someone lands after accepting a client or creator invitation (new
// account or existing): the campaign they were invited to. CampaignDetail
// sends a creator with terms to accept on to the accept-terms page.
export const invitationLandingPath = (campaignId?: string | null): string =>
	campaignId ? `/campaign-detail?campaignId=${encodeURIComponent(campaignId)}` : "/campaigns";
